import { useMutation } from "urql";
import { graphql } from "../gql";

const deleteSongsMutation = graphql(`
  mutation deleteSongs($bucket: String!, $ids: [ID!]!) {
    deleteSongs(bucket: $bucket, ids: $ids)
  }
`);

export function useDeleteSongs() {
  const [mutationResult, executeMutation] = useMutation(deleteSongsMutation);

  const deleteSongs = async (
    bucket: string,
    ids: string[],
  ): Promise<boolean> => {
    const result = await executeMutation({
      bucket,
      ids,
    });

    if (result.error) {
      console.error("Fehler beim Löschen der Songs:", result.error);
      return false;
    }

    return result.data?.deleteSongs !== undefined;
  };

  return {
    deleteSongs,
    fetching: mutationResult.fetching,
    error: mutationResult.error,
  };
}
